import { render, staticRenderFns } from "./FolderDeleteDialog.vue?vue&type=template&id=284f7df5&scoped=true"
import script from "./FolderDeleteDialog.vue?vue&type=script&lang=js"
export * from "./FolderDeleteDialog.vue?vue&type=script&lang=js"
import style0 from "./FolderDeleteDialog.vue?vue&type=style&index=0&id=284f7df5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284f7df5",
  null
  
)

export default component.exports